import Typography from './Typography';

export default Typography;
export * from './Typography';
